import { Dispatch, SetStateAction, useCallback } from "react";
import { useAsyncResult } from "../../Hooks/UseAsyncResult";
import { fetchExperimentPipelineMap } from "../../Api/ado.api";
import { useEv2ExperimentParams } from "../UseCurrentExtension";

export function useFetchPipelineId(
  stageType: string,
  setError: Dispatch<SetStateAction<any>>,
) {
  const { extensionFolder } = useEv2ExperimentParams();
  const func = useCallback(
    async (_disposable, _force) => {
      if (!extensionFolder) {
        return null;
      }
      let pipelineMap;
      const { rootExtension } = extensionFolder;
      try {
        const response = await fetchExperimentPipelineMap(rootExtension);
        pipelineMap = response;
      } catch (error) {
        console.error("Failed to fetch pipeline map:", error);
      }

      if (!pipelineMap) {
        return null;
      }

      const pipelineId =
        stageType === "single" || stageType === "SingleStage"
          ? pipelineMap.singleStagePipelineId
          : pipelineMap.unifiedPipelineId;

      return pipelineId;
    },
    [extensionFolder, stageType],
  );

  return useAsyncResult({
    func,
    setError,
  });
}
